import { LFlex } from "@components";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Colors } from "@styles/colors";
import classNames from "classnames";

export const CheckerIcon = ({
    title,
    subtitle,
    icon,
    error,
    active,
    errorText,
    success
}: CheckerIconProps): JSX.Element => {
    let bgColor = error ? "#F4D9D9" : "#fff";
    let iconColor = error ? "#B40000" : Colors.primaryBlue;
    const textColor = error ? "has-text-danger" : "has-text-primary-blue";

    if (!active) {
        bgColor = "#E2E3E4";
        iconColor = "#fff";
    }

    if (success) {
        bgColor = "#50B281";
        iconColor = "#fff";
    }

    const iconSize = active && !success ? "4x" : "2x";
    const bgSize = active && !success ? 140 : 80;

    const subtitleClasses = classNames("assessment-check-detail", "mt-4", textColor, "mw-80", "has-text-centered");

    return (
        <LFlex alignCenter justifyCenter className="assessment-check-item">
            {active && !success ? (
                <p className="assessment-check-title mb-5 has-text-weight-bold has-text-dark-blue">{title}</p>
            ) : (
                <p className="assessment-check-mobile-title has-text-weight-bold has-text-dark-blue">{title}</p>
            )}
            <div
                className="assessment-check-icon"
                style={{
                    borderRadius: 99,
                    backgroundColor: bgColor,
                    height: bgSize,
                    width: bgSize,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <FontAwesomeIcon icon={success ? faCheck : icon} color={iconColor} size={iconSize} />
            </div>
            {active && !success && <p className={subtitleClasses}>{error ? errorText : subtitle}</p>}
        </LFlex>
    );
};

interface CheckerIconProps {
    title: string;
    subtitle: string;
    icon: IconDefinition;
    error?: boolean;
    errorText?: string;
    tryNumber?: string;
    active?: boolean;
    success?: boolean;
}
